import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a7d0213a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "circle" }
const _hoisted_2 = { class: "circle-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"circle-content-center\" data-v-a7d0213a><div class=\"circle-content-center2\" data-v-a7d0213a><div style=\"position:absolute;left:0;right:0;\" data-v-a7d0213a><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"100\" height=\"100\" viewBox=\"0 0 80 80\" data-v-a7d0213a><path id=\"liuchengguanli\" d=\"M104.782,112a3.536,3.536,0,0,1,3.535,3.536v11.785a3.535,3.535,0,0,1-3.535,3.536H97.974v2.226h9.64a5.491,5.491,0,0,1,5.482,5.409v4.019h4.779a3.536,3.536,0,0,1,3.535,3.536v7.988a3.535,3.535,0,0,1-3.535,3.536H104.913a3.536,3.536,0,0,1-3.535-3.536v-7.988a3.535,3.535,0,0,1,3.535-3.536h4.779v-3.928a2.087,2.087,0,0,0-2.037-2.095H84.8a2.087,2.087,0,0,0-2.078,2.053v3.97H87.5a3.536,3.536,0,0,1,3.535,3.536v7.988A3.535,3.535,0,0,1,87.5,157.57H74.535A3.535,3.535,0,0,1,71,154.034v-7.988a3.535,3.535,0,0,1,3.535-3.536h4.779v-3.928a5.492,5.492,0,0,1,5.392-5.5h9.862v-2.226H86.713a3.535,3.535,0,0,1-3.535-3.536V115.536A3.536,3.536,0,0,1,86.713,112h18.07Z\" transform=\"translate(-58 -90)\" data-v-a7d0213a></path></svg></div></div></div>", 1)
const _hoisted_6 = { class: "circle-tips" }
const _hoisted_7 = { class: "circle-tips-line" }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "content-name" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-color" }, null, -1))

import { onMounted, ref } from 'vue';
import {
  pcModulePatientSex1,
  selfAdaption,
  useDataAssembly
  // sequence
} from './hooks';

export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-survey-2-3',
  props: {
    tableHeaderList: {},
    tableDataList: {}
  },
  setup(__props: any) {

const props = __props;
let data = useDataAssembly(props.tableHeaderList, props.tableDataList);
const TaskRef = ref<HTMLDivElement>();
const ContentRef = ref<HTMLDivElement>();
const scale = ref(1);

onMounted(async () => {
  await selfAdaption(TaskRef, ContentRef, scale);
  pcModulePatientSex1(TaskRef.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "TaskRef",
    ref: TaskRef,
    style: _normalizeStyle({
      transform: `scale(${scale.value})`,
      transformOrigin: '0 0'
    })
  }, [
    _createElementVNode("div", {
      class: "scale-circle",
      ref_key: "ContentRef",
      ref: ContentRef
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).tipData, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(`circle-content-item${index + 1}`),
              id: "circle",
              key: index
            }, _hoisted_4, 2))
          }), 128)),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).tipData.length, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(`circle-tips-line-item${index + 1}`),
                key: index,
                id: "tips-line"
              }, null, 2))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).tipData, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(`text-tips-item${index + 1}`),
              key: index
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(`text-tips-item${index + 1}-box`),
                id: "tips-text"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(`text-tips-item${index + 1}-box-bg`)
                }, null, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(`text-tips-item${index + 1}-box-text`)
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`text-tips-item${index + 1}-box-text-div`)
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (citem, cindex) => {
                      return (_openBlock(), _createElementBlock("div", { key: cindex }, [
                        _createElementVNode("span", null, _toDisplayString(citem.label) + "：", 1),
                        _createTextVNode(" " + _toDisplayString(citem.value), 1)
                      ]))
                    }), 128))
                  ], 2)
                ], 2)
              ], 2)
            ], 2))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).projectName, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              style: _normalizeStyle({ '--color': `var(--theme-color-${index + 1},#000)` }),
              key: index
            }, [
              _hoisted_10,
              _createElementVNode("div", null, _toDisplayString(item.value), 1)
            ], 4))
          }), 128))
        ])
      ])
    ], 512)
  ], 4))
}
}

})